import { TemplateGrid } from "../../../../../../components/template-grid/template-grid.component";
import React, { PropsWithChildren } from "react";

export const CbTemplateGrid = (props: PropsWithChildren<any>) => (
  <TemplateGrid container spacing={3}>
    {props.children}
  </TemplateGrid>
);
